import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
const steps = ['Download the volumes.', 'Open the templates.', 'Review the scripts.', 'Customize the documents.', 'Start implementing the system.'];
export function Guarantee() {
  return <section className="bg-steel-100 py-12 sm:py-16" aria-labelledby="guarantee-title" data-id="element-177" data-mp="29eggpgjs86c1">
      <div className="mx-auto w-full max-w-2xl px-4 sm:px-6" data-id="element-178" data-mp="2ed9u78z2jxc7">
        <div className="rounded-2xl border-2 border-green-600/30 bg-white p-5 sm:p-7" data-id="element-179" data-mp="2ecrs3vpq6owd">
          <div className="flex flex-col items-center text-center" data-id="element-180" data-mp="2jajhoj2wdyxe">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-green-600" data-id="element-181" data-mp="2oaxs27rz1kyl">
              <ShieldCheckIcon className="h-9 w-9 text-white" aria-hidden="true" data-id="element-182" data-mp="2sd2ikxn4i1h0" />
            </span>
            <h2 id="guarantee-title" className="mt-3 font-display text-2xl font-extrabold uppercase leading-tight text-ink-900 sm:text-3xl" data-id="element-183" data-mp="txy1jjm1z6cj">
              7-Day 100% money-back guarantee
            </h2>
          </div>

          <div className="mt-5 space-y-3 text-[15px] leading-relaxed text-ink-700 sm:text-base" data-id="element-184" data-mp="3nuq585xu1e5a">
            <p data-id="element-185" data-mp="3nsvlguyars2s">
              You shouldn’t have to take a risk to see whether the Premium
              Technician Kit™ is right for your business.
            </p>
            <p className="font-semibold text-ink-900" data-id="element-186" data-mp="3dy3nhq0sz37h">
              That’s why you have 7 full days to explore it.
            </p>
          </div>

          <ul className="mt-4 space-y-2" data-id="element-187" data-mp="ag3atxkay9nj">
            {steps.map((step, i) => <li key={step} className="flex items-center gap-3 rounded-lg bg-steel-100 px-3 py-2.5 text-sm font-medium text-ink-800 sm:text-base" data-id="element-188" data-mp="adz4l8yxkyk3" data-mpi={i}>
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ink-950 font-display text-xs font-bold text-gold-400" data-id="element-189" data-mp="k06qm5w40xy">
                  {i + 1}
                </span>
                {step}
              </li>)}
          </ul>

          <div className="mt-5 space-y-3 text-[15px] leading-relaxed text-ink-700 sm:text-base" data-id="element-190" data-mp="1d8xqnc8fkx5j">
            <p data-id="element-191" data-mp="1h9hmmch9puq3">
              If you decide during those 7 days that the Premium Technician Kit™
              isn’t what you expected, simply contact us and we’ll refund your
              purchase according to the guarantee terms.
            </p>
            <p className="font-semibold text-ink-900" data-id="element-192" data-mp="tkot0mo4byyn">
              No complicated process. No awkward conversation.
            </p>
          </div>

          <div className="mt-6" data-id="element-193" data-mp="ycq6ud0xpxqs">
            <CTAButton label="Try the Premium Technician Kit™ risk-free" sub="7-day money-back guarantee" size="md" data-id="element-194" data-mp="kjqrcb15k3j8" />
          </div>
        </div>
      </div>
    </section>;
}